/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import VideoTutorialComponents from 'components/VideoTutorial/videoTutorial.components';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const VideoTutorial = () => {
   return (
      <Fragment>
         <Helmet>
            <title>วีดีโอสอนการใช้งาน</title>
         </Helmet>
         <HasAccess
            roles={['Masteradmin']}
            permissions={["category-list"]}
            renderAuthFailed={<ErrorPage404/>}
         >
            <VideoTutorialComponents/>
         </HasAccess>
      </Fragment>
   );
};

export default VideoTutorial;
